import * as sessionStorageEx from 'utils/sessionStorageEx';

import { getLogger, localPreferences } from 'app-components/utils/core';

const logger = getLogger('utils/tabAuthExchange');
/////////////////////////////////////////
import { isDevSsoAttempt } from 'utils/devSso/capture';
/////////

let skipTabAuthExchange = false;
/////////////////////////////////////////
// A token link explicitly selects an account. Isolate this document so another
// tab cannot restore an old account or trigger logout/reload during the one-use
// exchange, and so this tab does not share the selected account with other tabs.
// Keep isolation after login; a clean-URL reload resumes normal tab exchange.
skipTabAuthExchange = isDevSsoAttempt();
/////////

if (!skipTabAuthExchange && !sessionStorageEx.getAuthSession()) {
  // Ask other tabs for session storage
  logger.log('request sessionStorage sync');
  localPreferences.setGetSessionStorage(Date.now());
}

function onStorage(event: StorageEvent): void {
  if (skipTabAuthExchange) return;
  if (event.newValue) {
    switch (event.key) {
      case localPreferences.keys.getSessionStorage: // trigger 'storage' event that contains current sessionStorage
        if (sessionStorageEx.getAuthSession()) {
          localPreferences.setSessionStorage(sessionStorage);
          localPreferences.removeSessionStorage(); // sessionStorage is in the event so remove it from localStorage
        }
        break;
      case localPreferences.keys.sessionStorage: //
        if (event.newValue === 'null') {
          // logout from another tab
          sessionStorageEx.clear();
          window.location.assign(window.location.href);
        } else if (!sessionStorageEx.getAuthSession()) {
          // copy sessionStorage from 'storage' event
          const data: Record<string, string> = JSON.parse(event.newValue);
          try {
            Object.keys(data).forEach((key) => sessionStorage.setItem(key, data[key]));
          } catch (e) {
            assert(false, e);
          }
          window.location.assign(window.location.href); // now when we have authSession copy in sessionStorege - re-init
        }
        break;
      default:
    }
  }
}

window.addEventListener('storage', onStorage, false);
